import { render } from "./ImagerieSein.vue?vue&type=template&id=66d12110&scoped=true"
import script from "./ImagerieSein.vue?vue&type=script&lang=js"
export * from "./ImagerieSein.vue?vue&type=script&lang=js"

import "./ImagerieSein.vue?vue&type=style&index=0&id=66d12110&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexk\\Documents\\Clonage Github\\IMS\\IMS\\ims-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d12110"]])

export default __exports__